import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  getPagePath,
  useSoyuzServer,
  useSoyuzRequest,
  useSoyuzLocales
} from '@spotahome/soyuz/client';
import { Mediator } from '@spotahome/soyuz-mediator';
import { getLoggedInUserInfo } from '@spotahome/soyuz-auth-client';
import { HeaderContainer as HeaderContainerComponent } from '@spotahome/ui-library';
import Metrics from '@spotahome/soyuz-tracking';

import {
  traditionalSignup,
  traditionalLogin,
  traditionalForgotPassword
} from '../api/traditional-login-client';

import { COMMON_LOGIN_MODAL } from '../channels';
import './HeaderContainer.scss';

const SESSION_EXPIRED_STATUS = 401;

const generateTraditionalSignupCB =
  locale => (name, email, password, marketingOptIn) =>
    traditionalSignup({ name, email, password, locale, marketingOptIn });

const traditionalLoginCB = (email, password) =>
  traditionalLogin({ email, password });

const traditionalForgotPasswordCB = async email => {
  try {
    await traditionalForgotPassword({ email });
  } catch (err) {
    console.log(err);
  }
};
const HeaderContainer = ({ renderExtraContent, renderLeftContent }) => {
  const { current: currentLocale } = useSoyuzLocales();
  const { currentRoute } = useSoyuzServer();
  const { params } = useSoyuzRequest();
  const [isTenantLogged, setIsTenantLogged] = useState(false);

  const handleLocaleChange = locale => {
    Metrics.ga.sendEvent('i18n', 'language-switcher', locale);

    window.location =
      getPagePath(currentRoute, { locale, params }) + window.location.search;
  };

  async function requestLoggedInUserInfo() {
    try {
      const response = await getLoggedInUserInfo();
      const userId = response.data.id;
      if (userId) {
        setIsTenantLogged(true);
      }
      return response;
    } catch (err) {
      if (err.response && err.response.status === SESSION_EXPIRED_STATUS) {
        Mediator.publish(COMMON_LOGIN_MODAL);
        setIsTenantLogged(false);
        return null;
      }
      throw new Error(err);
    }
  }

  return (
    <HeaderContainerComponent
      className="header-menu-wrapper"
      color="light"
      locales={{
        current: currentLocale,
        onChange: handleLocaleChange
      }}
      login={{
        getLoggedInUserInfo: requestLoggedInUserInfo,
        modalProps: {
          traditionalSignupCB: generateTraditionalSignupCB(currentLocale),
          traditionalLoginCB,
          forgotPasswordCB: traditionalForgotPasswordCB
        }
      }}
      links={{ changeCity: true }}
      renderExtraContent={renderExtraContent}
      renderLeftContent={renderLeftContent}
      isTopTenantVariant
      isTenantLogged={isTenantLogged}
      isContactUsEnabled
    />
  );
};

HeaderContainer.propTypes = {
  renderExtraContent: PropTypes.func,
  renderLeftContent: PropTypes.func
};

HeaderContainer.defaultProps = {
  renderExtraContent: () => {},
  renderLeftContent: () => {}
};

export default HeaderContainer;
